import { formatCurrency, checkNegative } from '@/services/convert'
import IndirectCostTakeoff from '@/components/DynamicComponents/Projects/NewConstruction/IndirectCostTakeoff'
import IndirectTreeTakeoffs from '@/components/DynamicComponents/Projects/IndirectTreeTakeoffs'

export default {
  components: {
    'indirect-cost-takeoff': IndirectCostTakeoff,
    'tree-takeoff': IndirectTreeTakeoffs,
  },
  props: ['costDetails', 'costType', 'assetId', 'dropdownData', 'isArchive'],
  data() {
    return {
      data: [],
      loading: false,
      formatCurrency: formatCurrency,
      activeKey: [],
      emptyImage: process.env.BASE_URL + 'resources/images/empty.png',
      visibleTakeoff: false,
      indirectCostId: undefined,
      actualCost: undefined,
      checkNegative: checkNegative,
    }
  },
  beforeMount() {},
  created() {
    this.data = this.costDetails
    if (this.data && this.data.length > 0) {
      this.activeKey.push(String(this.data[0].id))
    }
    this.$root.$on('hideLoader', this.hideLoader)
  },
  mounted() {},
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    hideLoader(flag) {
      this.loading = flag
    },

    assignIndirect(event, indirect) {
      event.stopPropagation()
      this.indirectCostId = indirect.id
      this.actualCost = indirect.unitCost
      this.visibleTakeoff = true
    },

    closeTakeoff() {
      this.indirectCostId = undefined
      this.visibleTakeoff = false
    },

    getLineItems(data, id) {
      const newData = [...this.data]
      const index = this.data.findIndex(i => i.id === id)

      if (index > -1) {
        newData[index].takeoffDetails = []
        newData[index].takeoffDetails = [...data]
        newData[index].isValidTakeoff = !data.some(
          i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
        )
      }
      this.data = [...newData]
      const isValidTakeoff = this.data.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      this.$emit('checkValidTab', this.costType, !isValidTakeoff)
    },

    updateCostDetails(id, ids, data) {
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === id)
      ids.forEach(element => {
        if (index > -1) {
          const takeoffIndex = newData[index].takeoffDetails.findIndex(
            i => i.id === element,
          )
          if (takeoffIndex > -1) {
            newData[index].takeoffDetails.splice(takeoffIndex, 1)
          }
        }
      })
      newData[index].isValidTakeoff = !data.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      if (data.length === 0) {
        if (index > -1) {
          newData[index].takeoffDetails = []
        }
      }
      this.data = [...newData]
      const isValidTakeoff = this.data.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      this.$emit('checkValidTab', this.costType, !isValidTakeoff)
    },

    checkValid(data) {
      if (data && data.length > 0) {
        return data.some(
          i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
        )
      } else {
        return false
      }
    },
  },
}
